import classNames from 'classnames/bind';

import styles from './S03.module.scss';
import waterpack from '../../../assets/images/products/tuo/s03/waterpack.jpg';

const cx = classNames.bind(styles);

const S03 = () => {
  return (
    <div className={cx('container')}>
      <h2 className={cx('headline1')}>Water Pack</h2>
      <h2 className={cx('headline2')}>투오 워터팩, 무엇인가요?</h2>
      <img src={waterpack} alt="미네랄 워터팩" />
      <div className={cx('columns')}>
        <div className={cx('column')}>
          <img src={require('../../../assets/images/products/tuo/s03/icon01.jpg')} alt="3중 레이어링 구조" />
          <div className={cx('title')}>
            5중
            <br />
            레이어링 구조
          </div>
        </div>
        <div className={cx('column')}>
          <img src={require('../../../assets/images/products/tuo/s03/icon02.jpg')} alt="폐기물 발생량 54% 절감" />
          <div className={cx('title')}>
            플라스틱 사용량
            <br />
            59% 감축
            <br />
            <small>
              <small>*자사 2L 페트와 동일용량(1L) 비교 기준</small>
            </small>
          </div>
        </div>
        <div className={cx('column')}>
          <img src={require('../../../assets/images/products/tuo/s03/icon03.jpg')} alt="재활용 분리배출 가능" />
          <div className={cx('title')}>
            재활용
            <br />
            분리배출 가능
          </div>
        </div>
        <div className={cx('column')}>
          <img src={require('../../../assets/images/products/tuo/s03/icon04.jpg')} alt="냉온수 출수 가능한 전용 디스펜서" />
          <div className={cx('title')}>
            냉온수 출수 가능한
            <br />
            전용 디스펜서
            <br />
            <small>
              <small>*별도 구매</small>
            </small>
          </div>
        </div>
      </div>
      <div className={cx('guide')}>
        얇고 가볍지만 쉽게 찢어지지 않는 PE, PA 재질의 5중 레이어링 구조 적용,
        <br />
        플라스틱 사용량을 줄이고 폐기물 부피를 줄입니다.
        <br />
        워터팩을 다 마신 후, 작게 접어 편리하게 분리배출 하세요.
      </div>
    </div>
  );
};

export default S03;
